module.exports = __webpack_public_path__ + "img/pr-1.f2f13ac3.png";